<span
  class="tooltip-wrapper"
  capraTooltip
  [tooltipContent]="tooltipContent"
  [tooltipContentIsHtml]="tooltipContentIsHtml"
  [tooltipSize]="tooltipSize"
  [tooltipPlacement]="tooltipPlacement"
  [tooltipIsDisabled]="tooltipIsDisabled"
  [tooltipDelay]="tooltipDelay"
  [tooltipForceShow]="tooltipForceShow"
  [tooltipOffset]="tooltipOffset"
  [tooltipAppendTo]="tooltipAppendTo"
  [tooltipInteractive]="tooltipInteractive"
>
  <ng-content></ng-content>
</span>
